<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">
      Assign "{{ data.property.name }}" to an Utsav
    </span>

    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">
      ×
    </button>
  </div>

  <div class="field">
    <span class="field-label">Utsav</span>
    <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
      <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="utsavId"
        placeholder="Select utsav" (selectionChange)="onUtsavChange()">
        @for(utsav of utsavList; track utsav.utsavId){
        <mat-option [value]="utsav.utsavId">{{ utsavLabel(utsav) }}</mat-option>
        } @empty {
        <mat-option [value]="null" disabled>No utsavs exist in this branch yet. Create one on the Utsavs screen.</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="rooms-section">
    <span class="field-label">Rooms to assign</span>

    @if(!roomsLoaded){
    <div class="muted">Loading rooms…</div>
    } @else if(rooms.length === 0){
    <div class="muted">No rooms in this property. Add rooms first.</div>
    } @else {
    <label class="select-all">
      <input type="checkbox" [checked]="allSelected" [disabled]="selectableRooms.length === 0"
        (change)="toggleSelectAll($event)" />
      Select all ({{ selectableRooms.length }} of {{ rooms.length }} rooms)
    </label>

    <div class="room-options">
      @for(room of rooms; track room.roomId){
      <label class="room-option" [class.room-disabled]="isRoomDisabled(room)">
        <input type="checkbox" [checked]="selectedRoomIds.includes(room.roomId)"
          [disabled]="isRoomDisabled(room)" (change)="toggleRoom(room.roomId, $event)" />

        <span>
          Room {{ room.roomNumber }} ·
          {{ room.roomType }} ·
          Capacity {{ room.capacity }} ·
          {{ room.gender }}
          @if(roomNote(room)){ <em class="room-note">({{ roomNote(room) }})</em> }
        </span>
      </label>
      }
    </div>
    }
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn"
      [disabled]="isLoading || !utsavId.value || selectedRoomIds.length === 0" (click)="submit()">
      Assign
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>